import { createSlice } from "@reduxjs/toolkit";

export const initOptionsReducer = createSlice({
  name: "initOptions",
  initialState: {
    isLoading: false,
    isError: false,
    message: "",
    storeList: [], //store 选项
    data: [],
    filterEnumList: [],
  },
  reducers: {
    setFilterEnum: (state, actions) => {
      return { ...state, filterEnumList: actions.payload };
    },
    setStore: (state, actions) => {
      return { ...state, storeList: actions.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFilterEnum, setStore } = initOptionsReducer.actions;

export default initOptionsReducer.reducer;
